import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "../styles/UsersDetails.css";

export default function UsersDetails() {
  const { id } = useParams();
  const [user, setUser] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      setLoading(true);
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/users/${id}`,
          {
            credentials: "include",
          },
        );

        const data = await res.json();

        if (!res.ok) {
          throw new Error(data.message || "Failed to fetch users");
        }

        toast.success("User Details fetched successfully");
        setUser(data);
      } catch (err) {
        toast.error(err.message || "Failed to fetch user");
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, [id]);

  const handleUpdate = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/users/admin/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify(user),
        },
      );

      const data = await res.json(user);

      if (!res.ok) {
        throw new Error(data.message || "Failed to update user");
      }

      toast.success("User updated successfully!");
      setUser(data.user);
      navigate("/dashboard/users");
    } catch (err) {
      toast.error(err.message || "Failed to update booking");
    }
  };

  const handleDelete = async () => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/users/admin/${id}`,
          {
            method: "DELETE",
            credentials: "include",
          },
        );
        const data = await res.json();
        toast.success(data.message || "User deleted successfully!");
        navigate("/dashboard/users");
      } catch (err) {
        toast.error(err.message || "Failed to delete user");
      }
    }
  };

  if (loading) {
    return <div>Loading user....</div>;
  }

  if (!user) {
    return <div>User not found</div>;
  }

  return (
    <div className="userDetail__container">
      <h2> User Details: {user.name}</h2>

      <div className="userDetail__details">
        <strong>Name: </strong>
        <input
          type="text"
          name="name"
          value={user.name}
          onChange={(e) => setUser({ ...user, name: e.target.value })}
        />
        <strong>Username: </strong>
        <input
          type="text"
          name="username"
          value={user.username}
          onChange={(e) => setUser({ ...user, username: e.target.value })}
        />
        <strong>Email: </strong>
        <input
          type="email"
          name="email"
          value={user.email}
          onChange={(e) => setUser({ ...user, email: e.target.value })}
        />
        {/* <strong>Password: </strong> */}
        {/* <input
          type="text"
          name="password"
          checked={user.password}
          onChange={(e) => setUser({ ...user, password: e.target.value })}
        /> */}
        <strong>isAdmin: </strong>
        <input
          type="checkbox"
          name="isAdmin"
          checked={user.isAdmin}
          onChange={(e) => setUser({ ...user, isAdmin: e.target.value })}
        />
      </div>
      <div className="userDetail__buttons">
        <button
          className="userDetail__button my-btn my-btn:hover"
          onClick={handleUpdate}
        >
          Save Updates
        </button>
        <button
          className="userDetail__button my-btn my-btn:hover"
          onClick={handleDelete}
        >
          Delete User
        </button>
      </div>
    </div>
  );
}
